/// <reference path="../include.ts" />

namespace project_common {

	export enum BannerLinkType {
		ios = 'ios', // don't change
		android = 'android', // don't change
	}
}
